export const TREATMENT_STATE_INACTIVE = "neaktivní";
